import { IconNames } from '@dixa/lib-shared-habla';
import { ELEMENT_TABLE } from 'lib-knowledge-document-structure/plate/table';
import {
  ELEMENT_BLOCKQUOTE,
  ELEMENT_CALLOUT,
  ELEMENT_CODE_BLOCK,
  ELEMENT_DIVIDER,
  ELEMENT_EMBED,
  ELEMENT_HEADING_LARGE,
  ELEMENT_HEADING_MEDIUM,
  ELEMENT_HEADING_SMALL,
  ELEMENT_HTML,
  ELEMENT_IMAGE,
  ELEMENT_INLINE_IMAGE,
  ELEMENT_OL,
  ELEMENT_PARAGRAPH,
  ELEMENT_UL,
  ELEMENT_VIDEO_EMBED,
  MyEditor,
  MyValueTypes,
} from 'lib-knowledge-document-structure/plateTypes';
import { Point } from 'lib-knowledge-document-structure/slate/package';

import { inlineImageActions } from '../createInlineImagePopupPlugin/inlineImage.store';

export const Blocks: ReadonlyArray<{
  type: MyValueTypes;
  label: string;
  icon: IconNames;
  insertAction?: (options: { point: Point; editor: MyEditor }) => void;
}> = [
  {
    type: ELEMENT_HEADING_LARGE,
    label: 'Heading Large',
    icon: 'heading-1',
  },
  {
    type: ELEMENT_HEADING_MEDIUM,
    label: 'Heading Medium',
    icon: 'heading-2',
  },
  {
    type: ELEMENT_HEADING_SMALL,
    label: 'Heading Small',
    icon: 'heading-3',
  },
  {
    type: ELEMENT_PARAGRAPH,
    label: 'Text',
    icon: 'text',
  },
  {
    type: ELEMENT_BLOCKQUOTE,
    label: 'Quote',
    icon: 'quote',
  },
  {
    type: ELEMENT_DIVIDER,
    label: 'Divider',
    icon: 'divider',
  },
  {
    type: ELEMENT_CALLOUT,
    label: 'Callout',
    icon: 'callout',
  },
  {
    type: ELEMENT_CODE_BLOCK,
    label: 'Code block',
    icon: 'code-block',
  },
  {
    type: ELEMENT_IMAGE,
    label: 'Image',
    icon: 'image',
  },
  {
    type: ELEMENT_INLINE_IMAGE,
    label: 'Inline Image',
    icon: 'image-inline',
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    insertAction: ({ point }): void => {
      inlineImageActions.show({ point });
    },
  },
  {
    type: ELEMENT_VIDEO_EMBED,
    label: 'Video',
    icon: 'video',
  },
  {
    type: ELEMENT_UL,
    label: 'Bulleted List',
    icon: 'list-ul',
  },
  {
    type: ELEMENT_OL,
    label: 'Numbered List',
    icon: 'list-ol',
  },
  {
    type: ELEMENT_EMBED,
    label: 'Embed',
    icon: 'external-link',
  },
  {
    type: ELEMENT_HTML,
    label: 'Custom Html',
    icon: 'widget-customize',
  },
  {
    type: ELEMENT_TABLE,
    label: 'Table',
    icon: 'th',
  },
];

export type Block = (typeof Blocks)[number];
